import { MyApes } from "./components/MyApes";
import { NewToken } from "./components/NewToken";
import { XToken } from "./components/XToken";
import { Home } from "./components/Home";
import { Profile } from "./components/Profile";
import { ViewToken } from "./components/ViewToken";
import { Bridge } from "./components/Bridge";
import { Auth } from "./components/Auth";

const AppRoutes = [
	{
		index: true,
		path: '/',
		element: <Home />
	},
	{
		path: '/my-apes',
		element: <MyApes />
	},
	{
		path: '/new-token',
		element: <NewToken />
	},
	{
		path: '/profile',
		element: <Profile />
	},
	{
		path: '/bridge',
		element: <Bridge />
	},
	{
		path: '/einstein',
		element: <Auth />
	},
	{
		path: '/x/:tweetId',
		element: <XToken />
	},
	{
		path: '/:tokenChain/:tokenAddress',
		element: <ViewToken />
	}
];

export default AppRoutes;
